<template>
    <b-row>
        <b-col cols="12"
               class="sub-tabs"
        >
            <b-button-group>
                <b-button :variant="!tab_1 ? 'primary' : 'secondary'"
                          class="mb-2"
                          @click="tab_1 = 0"
                >
                    GASES COMBURENTES
                </b-button>
                <b-button :variant="tab_1 ? 'primary' : 'secondary'"
                          class="mb-2"
                          @click="tab_1 = 1"
                >
                    CLASIFICACIÓN MEZCLAS
                </b-button>
            </b-button-group>

            <answers v-if="tab_1 === 0"
                     ref="answers"
                     code_question_group="GQ20"
                     danger_code="MCAL05"
            />

            <form_mode v-else/>
        </b-col>
    </b-row>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import answers from '../../../components/answers.vue';
import form_mode from './form_mode.vue';

export default {
    name: 'index',
    components: {
        answers,
        form_mode
    },
    data() {
        return {
            tab: 0,
            tab_1: 0
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'classification'
        ]),
        ...mapGetters('calculator', ['isStateAllowed'])
    },
};
</script>


<style lang="scss"
       src="../../../../../assets/calculator.scss"
/>
